import { useState, Suspense } from 'react'
import './App.css'
import '/node_modules/bootstrap/dist/js/bootstrap.js'
import '/node_modules/bootstrap/dist/css/bootstrap.css'
import 'react-toastify/dist/ReactToastify.css'
import './assets/styles/assets/assets.css'
import './assets/styles/assets/dashboard.css'
import './assets/styles/assets/amenities.css'
import './assets/styles/assets/visitor-gatepass.css'
import './assets/styles/assets/my-ticket.css'
import './assets/styles/assets/dues-payments.css'
import './assets/styles/assets/notices-events.css'
import './assets/styles/assets/gate-operations.css'
import './assets/styles/assets/directory-staff.css'
import './assets/styles/assets/visitor-monitoring.css'
import './assets/styles/assets/incident-reports.css'
import './assets/styles/assets/superadmin-dashboard.css'
import './assets/styles/assets/xpress-admins.css'
import './assets/styles/assets/xpress-admin-dashboard.css'
import './assets/styles/assets/technical-tickets.css'
import './assets/styles/assets/admin-dashboard.css'
import './assets/styles/assets/visitor-management-system.css'
import './assets/styles/assets/admin-ticket.css'
import './assets/styles/assets/admin-maintenance.css'
import './assets/styles/assets/admin-finance.css'
import './assets/styles/assets/admin-property.css'
import './assets/styles/assets/premise-list.css'
import './assets/styles/assets/premise-deep-dive.css'
import './assets/styles/assets/admin-staff-management.css'
import './assets/styles/assets/admin-roles-users.css'
import './assets/styles/assets/express-admin-roles-users.css'
import './assets/styles/assets/admin-report.css'
import './assets/styles/assets/monitoring-and-logs.css'
import './assets/styles/assets/premises-and-logs.css'
import './assets/styles/assets/audit-trail.css'
import './assets/styles/assets/platform-analytics.css'
import './assets/styles/assets/ip-and-access.css'
import './assets/styles/assets/document.css'
import './assets/styles/notifications/notifications.css'
import './assets/styles/sidebar/sidebar.css'
import './assets/styles/header/header.css'
import './assets/styles/user_login/userLogin.css'
import './assets/styles/master/main.css'
import './assets/styles/data_table/DataTable.css'
import "../src/i18n/i18n"
import { useRoutes } from 'react-router-dom'
import Routes from './routes/Route'
import FallbackPage from './routes/auth/FallbackPage'
import { ToastContainer } from 'react-toastify'
import { Tooltip } from 'react-tooltip'

function App() {

  const [collapsed, setCollapsed] = useState(false)

  function RouteLayout({ path }) {
    const element = useRoutes(path);
    return element;
  }

  return (
    <div className="App">

      <Suspense fallback={<FallbackPage />}>
        <RouteLayout path={Routes()} />
      </Suspense>

      <ToastContainer />
      <Tooltip id='global-tooltip' />

    </div>
  );
}

export default App;